<template>
  <v-card class="grey lighten-4">
    <v-card-title class="transparency pb-0">
      <MitsuisumitomoHeader v-if="getBookCompany === 'mitsuisumitomo'" />
      <RakutenHeader v-else-if="getBookCompany === 'rakuten'" />
      <DcCardHeader v-else-if="getBookCompany === 'dc'" />
      <LifeCardHeader v-else-if="getBookCompany === 'life'" />
      <v-progress-linear indeterminate :color="isLoading ? 'secondary' : 'transparent'" />
    </v-card-title>
    <v-card-text class="transparency">
      <Mitsuisumitomo v-if="!isLoading && getBookCompany === 'mitsuisumitomo'" :items="getItems" @emit="emitted" />
      <Rakuten v-else-if="!isLoading && getBookCompany === 'rakuten'" :items="getItems" @emit="emitted" />
      <DcCard v-else-if="!isLoading && getBookCompany === 'dc'" :items="getItems" @emit="emitted" />
      <LifeCard v-else-if="!isLoading && getBookCompany === 'life'" :items="getItems" @emit="emitted" />
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text color="secondary" @click="close">閉じる</v-btn>
      <v-spacer></v-spacer>
      <span v-if="isError" class="error--text caption mr-2">顧客が選択されていない項目があります</span>
      <v-btn depressed
        color="secondary"
        :disabled="!isValid"
        :loading="isLoading"
        @click="register">登録する</v-btn>
    </v-card-actions>
    <InsertClient ref="inserter" @done="insertClient" />
  </v-card>
</template>

<script>
import InsertClient from '@/components/modals/client'
import Mitsuisumitomo from './components/bank/mitsuisumitomo'
import MitsuisumitomoHeader from './components/bank/mitsuisumitomo/header'
import Rakuten from './components/bank/rakuten'
import RakutenHeader from './components/bank/rakuten/header'
import DcCard from './components/card/dc'
import DcCardHeader from './components/card/dc/header'
import LifeCard from './components/card/life'
import LifeCardHeader from './components/card/life/header'

export default {
  name: 'authorBbookUploadFiler',
  props: [ 'books' ],
  components: {
    InsertClient,
    Mitsuisumitomo,
    MitsuisumitomoHeader,
    Rakuten,
    RakutenHeader,
    DcCard,
    DcCardHeader,
    LifeCard,
    LifeCardHeader
  },
  data () {
    return {
      config: {
        status: {
          loading: false
        }
      },
      form: {
        valid: true,
        error: false
      },
      store: {
        type: '',
        company: '',
        item: {},
        items: [],
        file: {},
        dest: {}
      }
    }
  },
  methods: {
    init: function (req) {
      const { type, company, entries, file, dest } = req || {}
      this.$set(this.store, 'type', type)
      this.$set(this.store, 'company', company)
      this.$set(this.store, 'items', entries.length ? entries.map(it => {
        const { clients } = it
        return clients ? Object.assign(it, {
          cid: clients.length === 1 ? clients[0].id : '',
          clientType: clients.length === 1 ? clients[0].type : '',
          clientName: clients.length == 1 ? (clients[0].name ? clients[0].name.replace(',', '') : '') : ''
        }) : it
      }) : [])
      this.$set(this.store, 'file', file)
      this.$set(this.store, 'dest', dest)
      this.$set(this.form, 'valid', true)
      this.$set(this.form, 'error', false)
    },
    emitted: function (req) {
      const { action, data } = req || {}
      if (action && typeof this[action] === 'function') {
        this[action](data)
      }
    },
    register: function () {
      this.submit({ type: 'register' })
    },
    openClientInserter: function (req) {
      this.$set(this.store, 'item', req)
      if (this.$refs.inserter) {
        this.$refs.inserter.open()
      }
    },
    insertClient: function (req) {
      const { id } = this.store.item
      const { name } = req
      const cid = req.id || ''
      const idx = this.store.items.findIndex(it => { return it.id === id })
      if (cid && id && idx >= 0) {
        if (name && name.replace(',', '') === this.store.items[idx].client) {
          if (!this.store.items[idx].clients.length) {
            this.$set(this.store.items[idx], 'cid', cid)
            this.$set(this.store.items[idx], 'clietName', req.name ? req.name.replace(',', '') : '')
          }
          this.store.items[idx].clients.push(req)
        }
      }
    },
    selectClient: function (req) {
      const { item, client } = req
      const { id } = item
      const idx = this.store.items.findIndex(it => { return it.id === id })
      if (idx >= 0) {
        this.$set(this.store.items[idx], 'cid', client.id)
        this.$set(this.store.items[idx], 'clientType', client.type)
        this.$set(this.store.items[idx], 'clientName', client.name ? client.name.replace(',', '') : '')
      }
    },
    close: function () {
      this.$emit('close')
    },
    done: function () {
      this.$emit('done')
    },
    preSubmit: function (token, req) {
      const { type } = req || {}
      const { company, file, dest } = this.store
      const items = this.store.items.length ? this.store.items.filter(it => {
        return it.status === 'picked'
      }) : []
      const urls = {
        register: `${this.$url.api}bbook/insert/items`
      }
      const fds = {
        register: {
          book: {
            type: this.store.type,
            company
          }, items, file, dest
        }
      }
      const opts = {
        default: {
          headers: {
            'firebase-token': token
          }
        }
      }
      if (type && urls[type] && fds[type]) {
        if (type === 'register') {
          const invalids = items.length ? items.filter(it => {
            return !it.cid || it.content === ''
          }) : []
          if (invalids.length) {
            this.$set(this.form, 'valid', false)
            this.$set(this.form, 'error', true)
            setTimeout(() => {
              this.$set(this.form, 'valid', true)
            }, 3000)
            return false
          } else {
            this.$set(this.config.status, 'loading', true)
            this.$set(this.form, 'valid', true)
            this.$set(this.form, 'error', false)
          }
        }
        return { type, url: urls[type], fd: fds[type], option: opts[type] || opts.default }
      } else {
        return false
      }
    },
    submit: function (req) {
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        const dt = this.preSubmit(token, req)
        if (dt) {
          const { url, fd, type, option } = dt
          this.axios.post(url, fd, option).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        }
      })
    },
    postSubmit: function (req, submitType) {
      const type = submitType || ''
      if (type === 'register') {
        this.done()
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isValid () {
      return this.form.valid
    },
    isError () {
      return this.form.error
    },
    getBookCompany () {
      return this.store.company || ''
    },
    getItems () {
      return this.store.items
    }
  }
}
</script>